import { useEffect, useState } from "react";
import api from "../api/axios";
import Swal from "sweetalert2";

function UserList() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadServices();
  }, []);

  const loadServices = async () => {
    try {
      const response = await api.get(
        "/Login/GetUser"
      );

      setServices(response.data);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable to load services"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    

      <div className="card shadow">

        <div className="card-header bg-primary text-white">
          <h4 className="mb-0">
            User List
          </h4>
        </div>

        <div className="card-body">

          {loading ? (
            <div className="text-center">
              Loading...
            </div>
          ) : (

            <div className="table-responsive">

              <table className="table table-bordered table-striped">

                <thead className="table-dark">
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Mobile No.</th>
                    <th>Email ID</th>
                    <th>User Name</th>
                    <th>Role</th>
                    <th>Counter ID</th>
                    <th>Status</th>
                  </tr>
                </thead>

                <tbody>

                  {services.length > 0 ? (
                    services.map((item) => (
                      <tr key={item.id}>
                        <td>{item.id}</td>
                        <td>{item.fullName}</td>
                        <td>{item.mobileNo}</td>
                        <td>{item.emailId}</td>
                        <td>{item.userName}</td>
                        <td>{item.roleName}</td>
                        <td>
                       {item.counterId === 0 ? (
  <span className="badge bg-success">
    All
  </span>
) : (
  <span className="badge bg-warning">
    {item.counterId}
  </span>
)}

                           &nbsp;{item.serviceName}</td>
                        <td>
                          {/* {item.isActive
                            ? "Active"
                            : "Inactive"} */}

                                                 {item.isActive === true ? (
  <span className="badge bg-success">
  <i className="bi bi-eye-fill"></i>  Active
  </span>
) : (
  <span className="badge bg-danger">
   <i className="bi bi-eye-slash-fill"></i> Inactive
  </span>
)}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="5"
                        className="text-center"
                      >
                        No Record Found
                      </td>
                    </tr>
                  )}

                </tbody>

              </table>

            </div>

          )}

        </div>

      </div>

    
  );
}

export default UserList;